import queryString from "query-string";
import { useLocation, useParams } from "react-router-dom";

export const useCoordinator = () => {
  const { search } = useLocation();

  const {
    projectId: projectIdDirty = "",
    objectId = "",
    titleId = "",
    mainJournalId = "",
    supervisionId = "",
    journalVersionId = "",
    mainJournalVersionId = "",
    titleVersionId = "",
  } = useParams<{
    projectId: string;
    objectId: string;
    titleId: string;
    mainJournalId: string;
    supervisionId: string;
    journalVersionId: string;
    mainJournalVersionId: string;
    titleVersionId: string;
  }>();

  // projectId
  const isLegacyProject = projectIdDirty.startsWith("l");
  const projectId = projectIdDirty.slice(+isLegacyProject);

  return {
    isProjects: Boolean(projectId),
    projectId,
    isLegacyProject,
    objectId,
    titleId,
    mainJournalId,
    supervisionId,
    journalVersionId,
    mainJournalVersionId,
    titleVersionId,
    search: {
      ...queryString.parse(search),
    },
  };
};
